import React, { Component } from 'react';
import heroLow from '../../assets/images/illustrations/01-low.png';
import hero_png from '../../assets/images/illustrations/hp-first.png';
import hero from '../../assets/images/Autism-webp/Hero/AR/hero@3x.webp';
import en_hero_png from '../../assets/images/english/eng@3x.png';
import en_hero from '../../assets/images/Autism-webp/Hero/EN/hero@3x.webp';
import en_hero_low from '../../assets/images/english/eng@3x-low.png';
// import circle from '../../assets/images/icons/down.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { api_url } from '../../common/config';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
import windowSize from 'react-window-size';

class HomepageFirst extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageStatus: 'loading',
            mainContent: '',
            width: this.props.windowWidth,
            height: this.props.windowHeight,
        };
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    handleImageLoaded = () => {
        this.setState({ imageStatus: 'loaded' });
    };

    handleImageErrored = () => {
        this.setState({ imageStatus: 'failed to load' });
    };

    componentDidMount() {
        fetch(`${api_url}/autism/items/homepage_main_text`, {
            method: 'GET',
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    mainContent: res.data[0],
                });
            });
    }

    render() {
        return (
            <div className='hp hp-first'>
                <div className='hp-top'>
                    {i18next.language === 'ar' ? (
                        <div className='top-row'>
                            <div className='right-side'>
                                <p
                                    className='homepage-statement'
                                    dangerouslySetInnerHTML={{
                                        __html: this.state.mainContent.text,
                                    }}
                                />
                                {/* <div className='hp-btns'>
                                    <Link to='/register/child'>
                                        <button className='register-btn'>
                                            {this.state.mainContent.button_text}
                                        </button>
                                    </Link>
                                </div> */}
                            </div>
                            <div className='left-side'>
                                <picture>
                                    <source
                                        srcSet={hero_png}
                                        type='image/png'
                                    />
                                    <source srcSet={hero} type='image/webp' />
                                    <img
                                        alt='hero'
                                        src={hero}
                                        className={`hero-img`}
                                        onLoad={this.handleImageLoaded}
                                        onError={this.handleImageErrored}
                                    />
                                </picture>

                                {this.state.imageStatus === 'loaded' ? (
                                    <></>
                                ) : (
                                    <LazyLoadImage
                                        alt='hero'
                                        src={heroLow}
                                        className={`hero-img low-hero`}
                                    />
                                )}
                            </div>
                            <div id='circle' className='circle-container'>
                                {/* <img
                                    className='circle'
                                    src={circle}
                                    alt='circle'
                                /> */}
                            </div>
                        </div>
                    ) : (
                        <div className='top-row'>
                            <div className='right-side'>
                                <p
                                    className='homepage-statement en-homepage-statement text-left ml-5'
                                    dangerouslySetInnerHTML={{
                                        __html: this.state.mainContent.en_text,
                                    }}
                                />
                                {/* <div className='hp-btns'>
                                    <Link to='/register/child'>
                                        <button className='register-btn ml-5'>
                                            {
                                                this.state.mainContent
                                                    .en_button_text
                                            }
                                        </button>
                                    </Link>
                                </div> */}
                            </div>
                            <div className='left-side'>
                                <picture>
                                    <source
                                        srcSet={en_hero_png}
                                        type='image/png'
                                    />
                                    <source
                                        srcSet={en_hero}
                                        type='image/webp'
                                    />
                                    <img
                                        alt='hero'
                                        src={en_hero}
                                        className={`hero-img`}
                                        onLoad={this.handleImageLoaded}
                                        onError={this.handleImageErrored}
                                    />
                                </picture>

                                {this.state.imageStatus === 'loaded' ? (
                                    <></>
                                ) : (
                                    <LazyLoadImage
                                        alt='hero'
                                        src={en_hero_low}
                                        className={`hero-img low-hero`}
                                    />
                                )}
                            </div>
                            {this.state.width > 900 ? (
                                <div id='circle' className='circle-container'>
                                    {/* <img
                                        className='circle'
                                        src={circle}
                                        alt='circle'
                                    /> */}
                                </div>
                            ) : (
                                <></>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default windowSize(HomepageFirst);
